var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 695 726.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #006927;\n      }\n      .skin {\n        fill: #dcba8b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M608.76,726.35H87.41C112.46,600.54,219.65,506,348.09,506S583.71,600.54,608.76,726.35Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "skin",
    cx: 348.53,
    cy: 546.09,
    r: 76.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M624,277.23C606.91,429.38,499.88,554.54,346.77,554.46,199,554.39,81.22,429.89,69.54,277.23,55,87.39,193.66,0,346.77,0S647,72.39,624,277.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M133,320a61.7,61.7,0,0,1-61.7,61.71c-34.08,0-71.3-8.23-71.3-42.3s37.22-81.11,71.3-81.11A61.69,61.69,0,0,1,133,320Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M695,340.39c0,34.07-46.62,41.3-80.7,41.3a61.71,61.71,0,0,1,0-123.41C648.38,258.28,695,306.31,695,340.39Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset4);
export default __webpack_public_path__ + "static/media/Asset 4.17a46e09.svg";
export { ForwardRef as ReactComponent };